module.exports = __webpack_public_path__ + "src/images/mocha-logo.053c7b4ec885b34e484e33f39b4973e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mocha-logo.png
// module id = 103
// module chunks = 0